import { Box, BoxProps } from "@chakra-ui/react";

export const Shadow = ({ shouldShow, shadowProps = {} }: { shouldShow: boolean; shadowProps: BoxProps | undefined }) => {
    return (
        <Box
            opacity={shouldShow ? 1 : 0}
            transition="opacity 0.3s, transform 0.3s"
            position="absolute"
            bottom={0}
            left={2}
            right={2}
            height={7}
            pointerEvents="none"
            width="calc(100% - 34px)"
            background="linear-gradient(176deg, rgba(255, 255, 255, 0.00) 3.31%, rgba(255, 255, 255, 0.75) 34.55%, #FFF 96.71%)"
            {...shadowProps}
        />
    );
};
